import { render, staticRenderFns } from "./Mailto.vue?vue&type=template&id=c1b8ce9c&"
import script from "./Mailto.vue?vue&type=script&lang=ts&"
export * from "./Mailto.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports